import { render } from "./range_advance.vue?vue&type=template&id=64cbd9cf"
import script from "./range_advance.vue?vue&type=script&lang=js"
export * from "./range_advance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__